import React, { FC } from 'react'
import parse from 'html-react-parser'

import Wrapper from '../UI/Wrapper'
import { IndustryDetailsSection } from './styles'

interface IndustryDetailsProps {
  content: string
  theme?: 'Dark' | 'Light' | 'White'
}

const IndustryDetails: FC<IndustryDetailsProps> = ({ content, theme = 'Light' }) => {
  const parsedContent = parse(content)

  return (
    <IndustryDetailsSection className={`theme${theme}`}>
      <Wrapper>{parsedContent}</Wrapper>
    </IndustryDetailsSection>
  )
}

export default IndustryDetails
